<template>
  <div class="cashflow-type-income card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :up-to-now-label="titles.incomeProgress.actualsLabel"
                      :up-to-now-amount="Math.abs(income.upToNowAmount)"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.fixedIncome.actualsTitle"
                                 :categories="income.fixedIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :expense-category="titles.cashflowType"
                                 :title="titles.categorySections.fixedIncome.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                           v-for="transaction in transactionsWithActuals(transactions)"
                           :transaction="transaction.actual"
                           :can-edit-category="false"
                           v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>

    <predicted-category-sections :actuals-title="titles.categorySections.variableIncome.actualsTitle"
                                 :categories="income.variableIncome.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :expense-category="titles.cashflowType"
                                 :title="titles.categorySections.variableIncome.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="categoryName"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';

export default {
  name: 'CashflowTypeIncome',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    CASHFLOW_TYPE() {
      return cashflowViewConsts.cashflowTypes.income;
    },
    income() {
      return this.cashflowUITree[this.CASHFLOW_TYPE];
    },
    categoryName() {
      return cashflowViewConsts.CATEGORY_NAMES.VARIABLE_INCOME;
    },
    titles() {
      return {
        incomeProgress: {
          actualsLabel: 'כמה נכנס?',
        },
        categorySections: {
          fixedIncome: {
            actualsTitle: 'נכנס',
            mainTitle: 'פירוט הכנסות קבועות',
          },
          variableIncome: {
            actualsTitle: 'נכנס',
            mainTitle: 'פירוט הכנסות משתנות',
          },
        },
        cardTitle: 'הכנסות',
        cashflowType: 'הכנסות',
      };
    },
  },
  methods: {
    transactionsWithActuals(transactions) {
      return transactions.filter(t => t.actual);
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .past-cashflow-view-container {
    .cashflow-type-income {
      @include cashflow-card;

      .title {
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_green;
      }

      .cashflow-type-background-color {
        background-color: $riseup_green;
      }
    }
  }

</style>
